module.exports = __webpack_public_path__ + "static/detailgateway_font_white-d363cddfa52ed881960320530092f74a.png";